import { Line, mixins } from "vue-chartjs";

const { reactiveProp } = mixins
export default {
    extends: Line,
    mixins: [reactiveProp],
    props: ["chartData", "options"],
    data: () => ({
        interval: null
    }),
    // methods:{

    //   generateData() {
    //     for (let i = 0; i < 7; i++) {
    //       let randomValue = Math.floor(Math.random() * 40);
    //       this.newArray.push(randomValue);
    //     }
    // }
    // },
    beforeDestroy() {
        clearInterval(this.interval)
    },
    mounted() {

        // setTimeout(() => {

        this.renderChart(this.chartData, this.options);



        // }, 400);

        // this.generateData()
        //   setInterval(() => { 
        //     this.generateData()
        //   }, 5000)
        //     this.renderChart(
        //       {

        //         labels: [
        //           "16/08/2021",
        //           "17/08/2021",
        //           "18/08/2021",
        //           "19/08/2021",
        //           "20/08/2021",
        //           "21/08/2021",
        //           "22/08/2021",
        //         ],
        //         datasets: [
        //       {
        //         label: "Temperature",
        //         type: "line",
        //         data: this.newArray,
        //         backgroundColor: "rgba(20, 153, 242,.3)",

        //         borderWidth: 3
        //       },
        //       {
        //         label: "Humidity",
        //         type: "line",
        //         data: [40, 35, 45, 30, 33, 39, 42],
        //         backgroundColor: "rgba(247, 15, 15,.2)",
        //         borderWidth: 3
        //       }
        //   ]

        // },
        //       { 
        //       responsive: true, 
        //       maintainAspectRatio: false, 

        //        legend: {
        //             position: "bottom"
        //           },

        //   	      scales: {
        //           	yAxes: [{
        //               ticks: {
        //                     // min: 0,
        //                     // max: 10,
        //                     // beginAtZero: true,
        //                     // labelString: 'Manhour Average'
        //                       }
        //                     }],
        //             xAxes: [{
        //               ticks: {
        //                     min: 0,
        //                     max: 10,
        //                     beginAtZero: true,
        //                     labelString: 'Manhour Average'
        //                       },


        //                     }],
        //                   }    

        //       }

        //     );

    },


};